import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CandidateOperationService } from 'src/app/candidates-layout/operations/candidate-operation.service';
import { ExamOperationService } from 'src/app/exam-layout/operations/exam-operation.service';
import { OperationStatus } from 'src/app/exam-layout/operationstatus';
import { IExam } from 'src/app/interface/dto';
import { ExamScheduleOperationsService } from 'src/app/services/exam-schedule-operations.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { PopoverRef } from '../popover/popover-ref';

@Component({
  selector: 'app-setup-menu',
  templateUrl: './setup-menu.component.html',
  styleUrls: ['./setup-menu.component.css']
})
export class SetupMenuComponent implements OnInit {

  exam: IExam = null;
  operations = [];
  currentRoute = "";
  enableOps = false;
  opOpen$: Observable<boolean> = of(false);
  constructor(private route: Router, private popoverRef: PopoverRef<SetupMenuComponent>,
    private examService: ExamService, private exOp: ExamOperationService,
    private canOp: CandidateOperationService, private snackBar: MatSnackBar,
    private exSchOps: ExamScheduleOperationsService, public operationStatus: OperationStatus) {
  }


  async ngOnInit() {
    this.currentRoute = '' + this.route.routerState.snapshot.url.split('?')[0];
    //when route changes needs to be updated
    this.route.events.subscribe((e) => {
      this.currentRoute = '' + this.route.routerState.snapshot.url.split('?')[0];
      if (this.currentRoute == '/exams') {
        this.operations = this.exOp.setUpExamList();
      }
      if (this.currentRoute =='/questions-bank') {
        this.operations = this.getQuestionBankList();
      }
    });

    switch (this.currentRoute) {
      case '/exams':
        this.operations = this.exOp.setUpExamList();
        break;
      case '/questions-bank':
        this.operations = this.getQuestionBankList();
        break;
      case `/exams/${this.examService.selectedExamIds}/schedules`:
        break;
    }

    if (this.currentRoute == '/exams') {
      this.operations = this.exOp.setUpExamList();
    }
  }

  async processOp(route: any, origin: any) {

    if (route.includes("exam")) {
      this.exOp.processExamSetUp(route, origin);
    }
    this.popoverRef.close();
  }

  getQuestionBankList() {
    return [
      {
        icon: 'mat:group_work',
        label: 'Question Groups',
        route: `operations/exam/questiongroups`,
        id: 'examinations_question_groups'
      },
    ]
  }
}
